
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.958 15.833V9.5H1.583L9.5 2.375 17.417 9.5h-1.441a5.121 5.121 0 00-3.705-1.583 5.156 5.156 0 00-5.146 5.146c0 1.02.3 1.979.815 2.77H3.958z"}}),_c('g',{attrs:{"clip-path":"url(#clip0_15505_74186)"}},[_c('path',{attrs:{"d":"M12.601 12.877a.349.349 0 00-.275.408l1.001 5.152c.037.189.22.312.408.275a.353.353 0 00.202-.114l.724-.864 1.064 1.483c.082.11.217.159.348.134.05-.01.099-.02.141-.065l1.13-.817c.155-.115.196-.337.074-.486l-1.07-1.488 1.046-.413a.403.403 0 00.17-.154.344.344 0 00-.148-.476l-4.575-2.542-.004.005a.347.347 0 00-.236-.038zm2.022.219l-.175-.9 2.25-.438.175.9-2.25.438zm-.984-2.256l1.025-1.52.758.51-1.026 1.521-.757-.51zm-2.14-1.806l.9-.175.437 2.25-.9.174-.437-2.25zM10.05 16.16l1.026-1.52.758.51-1.026 1.521-.758-.51zm-.99-5.093l.511-.757 1.521 1.025-.51.758-1.522-1.026zm1.964 2.728l-2.25.438-.174-.9 2.25-.438.174.9z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_15505_74186"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(-11 54.95 -31.395)","d":"M0 0h11v11H0z"}})])])])
          )
        }
      }
    